export default class TelefoneData {
    id = null
    telefone = null
    tipoContato = null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/telefonemodel.js